import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CreateVoucherService {

  constructor(private readonly http: HttpClient) { }

  getCreateVoucherDetails(voucherId:any) {

    // let headers = new HttpHeaders();
    // headers = headers.set('partner', '1');    
    return this.http.get<any>(`mhvoucher/vouchers/id/${voucherId}?include=images&include=variants&include=assignees`)
  }

}
